<mat-card appearance="outlined" *ngIf="recipe" class="recipe" id="recipe">
    <mat-card-title class="card-title">{{ recipe?.title }} <span class="material-icons" (click)="onPrint()">print</span></mat-card-title>
    <mat-card-content>
        <div [innerHTML]="recipe.recipe">
        </div>
    </mat-card-content>
</mat-card>
